import React, { useEffect, useState, Fragment } from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { StaticImage } from "gatsby-plugin-image";
import NavigationDots from "../Carousel/NavigationDots";
import { Flex } from "theme-ui";
import SliderNavigation from "./SliderNavigation";
import { easeInOutExpo } from "../../utils/animations";
import { useSecureLinks } from "../../hooks/useSecureLinks";

interface Props {}

const steps = [
  {
    image: (
      <StaticImage
        src="../../images/home/Step1.png"
        alt="step 1"

        // height={515}
      />
    ),
    title: "Step 1: Apply",
    id: 2,
    instructions: (
      <ul>
        <li>
          <a href="https://secure.cashmoney.ca/LoanApplication/Province/">
            Online
          </a>
        </li>
        <li>
          <a href="find-a-store/">By Phone</a>
        </li>
        <li>
          <a href="find-a-store/">In a Branch</a> for Auto Equity Loan
        </li>
      </ul>
    ),
    instructionMobile: (
      <>
        <a href="https://secure.cashmoney.ca/LoanApplication/Province/">
          Online
        </a>{" "}
        | <a href="find-a-store/">By Phone</a> |{" "}
        <a href="find-a-store/">In a Branch</a> for Auto Equity
      </>
    ),
    height: 950,
  },
  {
    image: (
      <StaticImage
        src="../../images/home/Step2.png"
        alt="step 2"
        sx={
          {
            // maxWidth: "300px",
          }
        }
      />
    ),
    title: (
      <>
        Step 2: Verification, <br /> Loan Decision, Review & Sign{" "}
      </>
    ),
    id: 1,
    instructions: (
      <>
        <p>Provide required documentation:</p>
        <ul>
          <li>Age 18 or older</li>
          <li>Valid ID</li>
          <li>Steady source of income</li>
          <li>Open chequing account</li>
          <li>Phone number</li>
          <li>El and disability are accepted</li>
        </ul>
        <p>
          Receive a fast lending decision and review documents. Once approved,
          sign your loan agreement. 
        </p>
      </>
    ),
    instructionMobile: (
      <>
        <p>Provide required documentation:</p>
        <ul>
          <li>Age 18 or older</li>
          <li>Valid ID</li>
          <li>Steady source of income</li>
          <li>Open chequing account</li>
          <li>Phone number</li>
          <li>El and disability are accepted</li>
        </ul>
        <p>
          Receive a fast lending decision and review documents. Once approved,
          sign your loan agreement. 
        </p>
      </>
    ),
    height: 1063,
  },
  {
    image: <StaticImage src="../../images/home/Step3.png" alt="step 3" />,
    title: (
      <>
        Step 3:
        <br /> Get Your Funds
      </>
    ),
    id: 0,
    instructions: (
      <div sx={{ mb: 3, maxWidth: 350 }}>
        <em>Interac</em> e-Transfer<sup>®</sup> electronic funding or direct
        deposit to your bank account.
      </div>
    ),
    instructionMobile: (
      <>
        <em>Interac</em> e-Transfer<sup>®</sup> electronic funding or direct
        deposit to your bank account.
      </>
    ),
    height: 950,
  },
];
const stepsReversed = [...steps].reverse();

const LoanStepsSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [index, setIndex] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const secureLinks = useSecureLinks();

  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      defaultAnimation: {
        easing: (t) => easeInOutExpo(t),
        duration: 500,
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
    },
    []
  );

  return (
    <div
      sx={{
        height: [steps[currentSlide].height, null, null, "100%"],
        transition: "all .2s ease-out",
      }}
    >
      {/* desktop view */}
      <Flex
        data-sal="slide-up"
        data-sal-delay="0"
        data-sal-duration="800"
        data-sal-easing="easeOutQuart"
        sx={{
          display: ["none", null, null, "flex"],
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
          width: "100vw",
        }}
      >
        <div
          sx={{
            position: "relative",
            height: 354,
            width: "100%",
            bg: "brand.powderBlue",
            mt: 5,
            mb: [0, null, null, 110],
          }}
        >
          <div
            sx={{
              display: ["none", null, null, "block"],
              height: ["100%", null, null, 354],
              width: ["100%", null, null, "50%"],
              top: [350, null, null, 0],
              zIndex: 0,
              right: ["0", null, null, 0],
              left: ["0", null, null, "50%"],
              bg: "brand.neutralGrey",
              position: "absolute",
            }}
          ></div>

          <div
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translate(-50%, 0)",
              top: -60,
              display: "flex",
              justifyContent: "center",
              width: 241,
              height: 506,
              overflow: "hidden",
              zIndex: 1,
            }}
          >
            <div
              sx={{
                transform: `translateY(-${
                  index == 0 ? index * 569 : index * 569
                }px)`,
                transition: "all .5s cubic-bezier(.64,-0.01,.37,.99)",
                //   transitionDelay: ".1s",
              }}
            >
              {steps.map((child: any, i: number) => (
                <div
                  key={i}
                  sx={{
                    mb: 5,
                    // height: 559,
                  }}
                >
                  {child.image}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          sx={{
            position: "relative",
            top: [100, null, null, 0],
          }}
        >
          <NavigationDots
            {...{ index, setIndex, slides: [3, 1, 2], arrows: true }}
          />
        </div>
        <Fragment>
          <div
            sx={{
              display: ["none", null, null, "flex"],
              position: ["relative", null, null, "absolute"],
              right: ["0%", null, null, "50%"],
              transform: ["none", null, null, "translate(-33%, -50%)"],
              top: [100, null, null, 250],
              width: [375, null, null, 375, 450],
              height: [200, null, null, 253],
              pr: [0, null, null, 0, 4],
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            <div
              sx={{
                display: "flex",
                transform: [
                  `translateX(${index * -375}px)`,
                  null,
                  null,
                  `translateX(${index * -450}px)`,
                ],
                left: ["0%", null, null, 0],
                position: "absolute",
                transition: "all .5s cubic-bezier(.64,-0.01,.37,.99)",
              }}
            >
              {steps.map((child: any, i: number) => (
                <div
                  key={i}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h2
                    sx={{
                      width: [375, null, null, 450],
                      variant: "text.h1HeaderRegular",
                      fontSize: "32px",
                      textAlign: "left",
                      fontWeight: "bold",
                      opacity: index === i ? 1 : 0,
                      transition: "opacity 0.5s ease-in-out",
                    }}
                  >
                    {child.title}
                  </h2>
                </div>
              ))}
            </div>
          </div>
          <div
            sx={{
              display: ["none", null, null, "flex"],
              position: ["relative", null, null, "absolute"],
              left: ["0%", null, null, "33%", "50%"],
              transform: ["none", null, null, null, "translate(33%, -50%)"],
              top: [100, null, null, null, "40%"],
              width: ["100%", null, null, null, 450, 550],
              pl: [0, null, null, 0, 3],
              overflow: "hidden",
              bg: ["brand.neutralGrey", null, null, "transparent"],
            }}
          >
            <div
              sx={{
                display: "flex",
                transform: [
                  `translateX(${(steps[index].id - 1) * -400}px)`,
                  null,
                  null,
                  null,
                  `translateX(${steps[index].id * -450}px)`,
                  `translateX(${steps[index].id * -550}px)`,
                ],
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
                transition: "all .5s cubic-bezier(.64,-0.01,.37,.99)",
              }}
            >
              {stepsReversed.map((child: any, i: number) => (
                <div
                  key={child.id}
                  sx={{
                    width: ["100%", null, null, null, 450, 550],
                    px: 3,
                    // borderLeft: ["none", null, null, "1px solid #000"],
                  }}
                >
                  <div
                    sx={{
                      fontWeight: 600,
                      fontSize: 16,
                      display: ["none", null, null, "block"],
                      opacity: steps[index].id === i ? 1 : 0,
                      transition: "opacity 0.5s ease-in-out",
                      ul: {
                        listStyle: "disc",
                        px: 4,
                        py: 3,
                      },
                      a: {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    {child.instructions}
                  </div>
                  {i % 2 == 0 ? (
                    <a
                      href={secureLinks.loanApplication}
                      sx={{
                        position: "relative",
                        variant: "buttons.newPrimary",
                        maxWidth: 188,
                        width: "100%",
                        opacity: steps[index].id === i ? 1 : 0,
                        transition: "opacity 0.5s ease-in-out",
                        mt: [0, null, null, 2],
                      }}
                    >
                      Apply Now
                    </a>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            </div>
          </div>
        </Fragment>
      </Flex>
      {/* desktop view */}
      {/* Mobile view */}
      <Flex
        sx={{
          display: ["block", null, null, "none"],
          position: "relative",
        }}
      >
        <div ref={sliderRef} className="keen-slider">
          <div
            sx={{
              position: "absolute",
              bg: "brand.powderBlue",
              height: 400,
              width: "100%",
              top: 70,
              zIndex: 1,
            }}
          ></div>
          <div
            sx={{
              position: "absolute",
              bg: "brand.neutralGrey",
              height: 500,
              top: 400,
              width: "100%",
            }}
          ></div>

          {steps.map((child: any, i: number) => (
            <div
              className={`keen-slider__slide`}
              sx={{
                zIndex: 2,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
              key={i}
            >
              <div
                sx={{
                  maxWidth: 250,
                }}
              >
                {child.image}
              </div>
              <h2
                sx={{
                  variant: "text.h1HeaderRegular",
                  fontSize: "32px",
                  textAlign: "center",
                  fontWeight: "bold",
                  mt: "85px",
                  bg: "brand.neutralGrey",
                  width: "100%",
                }}
              >
                {child.title}
              </h2>
              <div
                sx={{
                  fontWeight: 600,
                  fontSize: 16,
                  py: 4,
                  px: 5,
                  textAlign: i == 1 ? "left" : "center",
                  bg: "brand.neutralGrey",
                  width: "100%",
                  ul: {
                    listStyle: "disc",
                    px: 4,
                    py: 3,
                  },
                  a: {
                    textDecoration: "underline",
                  },
                }}
              >
                {child.instructionMobile}
              </div>
              {i % 2 == 0 ? (
                <a
                  href={secureLinks.loanApplication}
                  sx={{
                    position: "relative",
                    variant: "buttons.newPrimary",
                    maxWidth: 188,
                    width: "100%",
                    transition: "opacity 0.5s ease-in-out",
                    mt: [0, null, null, 2],
                  }}
                >
                  Apply Now
                </a>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
        <div
          sx={{
            position: "absolute",
            top: 460,
            mt: 5,
            pb: 4,
            pt: 3,
            zIndex: 9,
            display: ["flex", null, null, "none"],
            justifyContent: "center",
            left: "50%",
            width: "100%",
            transform: "translateX(-50%)",
          }}
        >
          {loaded && instanceRef.current && (
            <SliderNavigation
              instanceRef={instanceRef}
              currentSlide={currentSlide}
            />
          )}
        </div>
      </Flex>

      {/* Mobile view */}
    </div>
  );
};

export default LoanStepsSlider;
